import React from "react";
import { Helmet } from 'react-helmet';
import "./TermsAndCondition.css"; // Make sure to import the CSS file

const TermsAndCondition = () => {
  return (
    <>
      <Helmet>
        <title>Terms and Conditions - Burj Tech Consultancy</title>
        <meta name="description" content="Review our Terms and Conditions for using www.btcglobal.info. Covers scope of services, user responsibilities, payment terms, intellectual property, liability, and dispute resolution under Indian law." />
        <link rel="canonical" href="https://www.burjtechconsultancy.com/terms-and-conditions" />
      </Helmet>
      <div className="container my-5 terms-container">
        <div className="card shadow-sm p-4 border-0">
          <h1 className="fw-bold mb-3 text-primary">Terms and Conditions</h1>
          <p className="text-muted">Last updated: October 2025</p>

          <p>
            These Terms and Conditions ("Agreement") constitute a legally binding
            agreement between <strong>BURJ TECH CONSULTANCY</strong> ("Company",
            "we", "our", or "us") and you ("User", "Customer", or "you") governing
            your access to and use of our website{" "}
            <strong>www.btcglobal.info</strong> and related services (collectively,
            the "Service"). By accessing or using our Service, you acknowledge
            that you have read, understood, and agree to be bound by this
            Agreement.
          </p>

          <h4 className="mt-4">1. Scope of Services</h4>
          <p>
            We provide online retail and e-commerce services that allow customers
            to browse, purchase, and manage various products. All product details,
            pricing, and availability are displayed on our website and are subject
            to change without prior notice. We reserve the right to modify or
            discontinue any portion of the Service at any time without liability.
          </p>

          <h4 className="mt-4">2. Product Information</h4>
          <p>
            We make every effort to display accurate product information,
            descriptions, and prices. However, typographical or pricing errors may
            occur. In such cases, we reserve the right to correct errors or cancel
            orders placed under incorrect pricing or information.
          </p>

          <h4 className="mt-4">3. User Responsibilities</h4>
          <p>
            By using our Service, you agree to provide accurate and up-to-date
            personal, billing, and contact information. You are responsible for
            maintaining the confidentiality of your account credentials and all
            activities occurring under your account.
          </p>
          <ul>
            <li>Use the Service only for lawful purposes.</li>
            <li>Refrain from engaging in fraudulent or misleading activities.</li>
            <li>
              Not upload or transmit viruses, malware, or harmful code to the
              Service.
            </li>
            <li>
              Notify us immediately in case of unauthorized account use or
              security breaches.
            </li>
          </ul>

          <h4 className="mt-4">4. Payment and Billing Terms</h4>
          <p>
            All payments must be made in Indian Rupees (INR) and are securely
            processed via <strong>Cashfree Payments India Pvt. Ltd.</strong> or
            other authorized payment gateways. We do not store sensitive financial
            data such as credit card numbers or CVV details.
          </p>
          <p>
            Once an order is placed, payment is required to confirm the purchase.
            You agree to pay all applicable fees, taxes, and shipping charges.
            Refunds or cancellations will be handled as per our{" "}
            <a href="/refund-policy" className="text-primary">Refund & Cancellation Policy</a>.
          </p>

          <h4 className="mt-4">5. Usage Restrictions</h4>
          <p>
            You agree not to use the Service for any unlawful or prohibited
            activity, including but not limited to:
          </p>
          <ul>
            <li>
              Attempting to gain unauthorized access to our systems or networks.
            </li>
            <li>Impersonating another person or entity.</li>
            <li>
              Using automated systems or bots to interact with the Service without
              permission.
            </li>
            <li>
              Engaging in activities that disrupt or interfere with the
              performance of the Service.
            </li>
          </ul>

          <h4 className="mt-4">6. Intellectual Property Ownership</h4>
          <p>
            All materials on this website, including text, graphics, images,
            software, trademarks, and logos, are the intellectual property of{" "}
            <strong>BURJ Tech Consultancy</strong> or its licensors. You may not
            copy, reproduce, distribute, modify, or create derivative works based
            on our content without prior written consent.
          </p>

          <h4 className="mt-4">7. Limitation of Liability</h4>
          <p>
            To the maximum extent permitted by law,{" "}
            <strong>BURJ Tech Consultancy</strong> shall not be liable for any
            indirect, incidental, consequential, or special damages arising out of
            or in connection with your use or inability to use the Service,
            products, or third-party payment gateways. Our total liability shall
            not exceed the total amount paid by you for the product or service.
          </p>

          <h4 className="mt-4">8. Indemnification</h4>
          <p>
            You agree to indemnify, defend, and hold harmless{" "}
            <strong>BURJ Tech Consultancy</strong>, its directors, officers,
            employees, and affiliates from any claims, damages, or expenses
            arising out of your use of the Service, violation of these Terms, or
            infringement of third-party rights.
          </p>

          <h4 className="mt-4">9. Termination</h4>
          <p>
            We reserve the right to suspend or terminate your access to the
            Service at any time without prior notice if you breach these Terms or
            engage in any activity that may harm the Company or other users.
          </p>

          <h4 className="mt-4">10. Force Majeure</h4>
          <p>
            We shall not be held liable for any delay or failure in performance
            caused by circumstances beyond our reasonable control, including but
            not limited to natural disasters, war, acts of terrorism, labor
            disputes, power failures, or internet outages.
          </p>

          <h4 className="mt-4">11. Dispute Resolution</h4>
          <p>
            Any dispute arising out of or related to these Terms shall first be
            resolved amicably through mutual discussion within 15 business days.
            If unresolved, it shall be referred to arbitration under the
            Arbitration and Conciliation Act, 1996. The arbitration shall be held
            in <strong>[Tiruvallur, Tamilnadu]</strong>, India. The courts of{" "}
            <strong>[Tiruvallur, Tamilnadu]</strong> shall have exclusive jurisdiction.
          </p>

          <h4 className="mt-4">12. Governing Law</h4>
          <p>
            These Terms shall be governed by and construed in accordance with the
            laws of India, without regard to conflict of law principles.
          </p>

          <h4 className="mt-4">13. Privacy Policy</h4>
          <p>
            Your use of the Service is also governed by our{" "}
            <a href="/privacypolicy" className="text-primary">Privacy Policy</a>, which describes how we
            collect, use, and protect your personal information.
          </p>

          <h4 className="mt-4">14. Amendments</h4>
          <p>
            We may modify or update these Terms at any time, with or without
            notice. Updated versions will be posted on this page, and your
            continued use of the Service constitutes acceptance of the revised
            Terms.
          </p>

          <h4 className="mt-4">15. Contact Information</h4>
          <p>
            For any questions or concerns regarding these Terms and Conditions,
            please contact us at:
          </p>
          <p>
            📧 <strong>www.btcglobal.info/contact</strong>
            <br />
            📞 <strong>+91-9444369625</strong>
            <br />
            🏢 <strong>No.469/ Pavalamalli St, Narasimhapuram, Kakkalur, Tiruvallur - 602003</strong>
          </p>
        </div>
      </div>
    </>
  );
};

export default TermsAndCondition;